import React from 'react';
import classNames from 'classnames';
import { sharedDragController } from 'javascripts/dnd/controllers/DragController';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import RecordTypePicker from './RecordTypePicker';
import FieldsSidebar from './FieldsSidebar';
import CardPreview from './CardPreview';
import styles from './styles.module.css';
import CardLayoutEditorController from '../controllers/CardLayoutEditorController';

const LayoutEditorContents = () => {
  const controller = useController(CardLayoutEditorController);
  const {
    currentRecordLayoutKey,
    state: { saving },
  } = controller;
  const { dragging } = sharedDragController.state;

  return (
    <>
      <aha-modal-header modal-title='Customize record cards' />
      <div
        className={classNames({
          [styles.editor]: true,
          [styles.dragging]: dragging,
        })}
      >
        <RecordTypePicker />
        <div className={styles.editorRow}>
          <FieldsSidebar key={currentRecordLayoutKey} />
          <CardPreview />
        </div>
      </div>
      <aha-modal-footer>
        <aha-button
          disabled={saving || null}
          kind='primary'
          onClick={() => {
            if (!saving) controller.actionSave();
          }}
        >
          {saving ? 'Saving…' : 'Save'}
        </aha-button>
        <div slot='secondary_actions'>
          <aha-button kind='link' onClick={() => controller.actionCloseModal()}>
            Cancel
          </aha-button>
        </div>
      </aha-modal-footer>
    </>
  );
};

export default view(LayoutEditorContents);
